import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import Code from '../components/Code';
import { C2_EVOLUTION_ENABLED } from '../evolutionFlag';

export default function SignalMap() {
  const qc = useQueryClient();
  const signals = useQuery({ queryKey: ['signals'], queryFn: api.signals });
  const inject = useMutation({
    mutationFn: (id: string) => api.injectSignal(id, 1.0),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['signals'] }),
  });

  return (
    <div>
      <div className="ph">Signal-to-Spine Map</div>
      <div className="h2">Signal → Spine routing</div>

      <div className="panel">
        <table className="signal-map-table">
          <thead>
            <tr>
              <th>Signal</th>
              <th>Assumption tested</th>
              <th className="center">Obj</th>
              <th className="center">Node</th>
              <th>Owner</th>
              <th className="center">State</th>
              <th className="center">Inject</th>
              {C2_EVOLUTION_ENABLED && <th className="center">Cascade</th>}
            </tr>
          </thead>
          <tbody>
            {signals.data?.map((s) => (
              <tr key={s.id}>
                <td className="signal-map-signal-cell">
                  <div className="signal-map-name">{s.name}</div>
                  <div className="signal-map-code"><Code id={s.id} kind="signal" compact codeOnly /></div>
                </td>
                <td className="small signal-map-code-cell"><Code id={s.assumption_id} kind="assumption" compact truncate /></td>
                <td className="center"><span className="tag amber">{s.objective_id}</span></td>
                <td className="center"><span className="tag teal signal-map-stage"><Code id={s.money_node_id} kind="stage" compact truncate /></span></td>
                <td className="small">{s.owner}</td>
                <td className="center">
                  {s.tripwire_breached ? (
                    <span className="blockedchip">BREACHED</span>
                  ) : (
                    <span className="tag muted">nominal {s.current_value.toFixed(2)}</span>
                  )}
                </td>
                <td className="center">
                  <button
                    type="button"
                    className="btn ghost"
                    style={{ minHeight: 'auto', padding: '6px 12px', fontSize: 13 }}
                    onClick={() => inject.mutate(s.id)}
                    disabled={inject.isPending}
                  >
                    ⚡
                  </button>
                </td>
                {C2_EVOLUTION_ENABLED && (
                  <td className="center">
                    {s.id === 'S-09' ? (
                      <Link to="/cascade" className="btn ghost" style={{ minHeight: 'auto', padding: '6px 12px', fontSize: 13, textDecoration: 'none' }}>trace</Link>
                    ) : (
                      <span className="small faint">-</span>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
